<!-- Start Breadcrumbs -->
<app-breadcrumbs title="API KEY" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->
<div class="row">
    <div class="col-lg-4">
        <div class="card card-height-100">
            <div class="card-body">
                <h5 class="card-title mb-3">Developer Plan</h5>
                <div class="progress animated-progress custom-progress mb-1">
                    <div class="progress-bar bg-info" role="progressbar" style="width: 38%" aria-valuenow="38" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <p class="text-muted mb-2">You used 215 of 2000 of your API</p>
                <div class="text-end">
                    <button type="button" class="btn btn-success btn-sm create-btn" data-bs-toggle="modal" data-bs-target="#api-key-modal" (click)="openModal(content)">Create API Key</button>
                </div>
            </div>
        </div>
    </div>
    <!--end col-->
    <div class="col-lg-4">
        <div class="card card-animate card-height-100">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="fw-medium text-muted mb-0">Successful conversions</p>
                        <h2 class="mt-4 ff-secondary fw-semibold">
                            <span [countUp]="50" class="counter-value" [options]="option"></span>
                        </h2>
                        <p class="mb-0 text-muted"><span class="badge bg-light text-success mb-0"><i class="ri-arrow-up-line align-middle"></i> 8.24 % </span> 7 last week</p>
                    </div>
                    <div>
                        <div class="avatar-sm flex-shrink-0">
                            <span class="avatar-title bg-success-subtle rounded-circle fs-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle text-success">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
            </div><!-- end card body -->
        </div>
    </div>
    <!--end col-->
    <div class="col-lg-4">
        <div class="card card-animate card-height-100">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="fw-medium text-muted mb-0">Failed conversions</p>
                        <h2 class="mt-4 ff-secondary fw-semibold">
                            <span [countUp]="8" class="counter-value" [options]="option"></span>
                        </h2>
                        <p class="mb-0 text-muted"><span class="badge bg-light text-danger mb-0"><i class="ri-arrow-down-line align-middle"></i> 25.87 % </span> 7 last week</p>
                    </div>
                    <div>
                        <div class="avatar-sm flex-shrink-0">
                            <span class="avatar-title bg-danger-subtle rounded-circle fs-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon text-danger">
                                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2">
                                    </polygon>
                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
            </div><!-- end card body -->
        </div>
    </div>
    <!--end col-->
</div>
<!-- end row -->
<div class="row">
    <div class="col-lg-12">
        <div class="card" id="apiKeyList">
            <div class="card-header d-flex align-items-center">
                <h5 class="card-title flex-grow-1 mb-0">API Keys</h5>
                <div class="d-flex gap-1 flex-wrap">
                    <button class="btn btn-soft-danger" id="remove-actions" style="display: none" (click)="confirm(deleteModel,'')"><i class="ri-delete-bin-2-line"></i></button>
                    <button type="button" class="btn btn-success create-btn" data-bs-toggle="modal" data-bs-target="#api-key-modal" (click)="openModal(content)"><i class="ri-add-line align-bottom me-1"></i> Add API Key</button>
                </div>
            </div>
            <div class="card-body">
                <div>
                    <div class="table-responsive table-card mb-3">
                        <table class="table align-middle table-nowrap mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col" style="width: 50px;">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="checkAll" value="option" [(ngModel)]="masterSelected" (change)="checkUncheckAll($event)">
                                        </div>
                                    </th>
                                    <th class="sort d-none" (click)="onSort('id')">Id</th>
                                    <th class="sort" (click)="onSort('name')">Name</th>
                                    <th class="sort" (click)="onSort('createdby')">Created By
                                    </th>
                                    <th class="sort" (click)="onSort('key')">API Key</th>
                                    <th class="sort" (click)="onSort('status')">Status</th>
                                    <th class="sort" (click)="onSort('create_date')">Create
                                        Date</th>
                                    <th class="sort" (click)="onSort('expiry_date')">Expiry
                                        Date</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody class="list form-check-all">
                                @for ( data of apikeys; track $index) {
                                <tr id="a_{{data.id}}">
                                    <th scope="row">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" name="checkAll" value="{{data._id}}" [(ngModel)]="data.state" (change)="onCheckboxChange($event)">
                                        </div>
                                    </th>
                                    <td class="id" style="display:none;">
                                        <a href="javascript:void(0);" class="fw-medium link-primary">#VZ001</a>
                                    </td>
                                    <td class="name">{{data.name}}</td>
                                    <td class="createBy">{{data.createdby}}</td>
                                    <td class="apikey">
                                        <input type="text" class="form-control apikey-value" value="{{data.key}}">
                                    </td>
                                    <td class="status"><span class="badge bg-{{data.color}}-subtle text-{{data.color}}">{{data.status}}</span>
                                    </td>
                                    <td class="create_date">{{data.create_date}}</td>
                                    <td class="expiry_date">{{data.expiry_date}}</td>
                                    <td>
                                        <div ngbDropdown class="dropdown">
                                            <button ngbDropdownToggle class="btn btn-soft-secondary btn-sm dropdown arrow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="ri-more-fill align-middle"></i>
                                            </button>
                                            <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
                                                <li><a class="dropdown-item edit-item-btn" href="javascript:void(0);" data-bs-toggle="modal" (click)="RenameModal(content,$index)">Rename</a>
                                                </li>
                                                <li><a class="dropdown-item regenerate-api-btn" href="javascript:void(0);" data-bs-toggle="modal" (click)="RenameModal(content,$index)">Regenerate Key</a></li>
                                                <li><a class="dropdown-item disable-btn" href="javascript:void(0);">Disable</a></li>
                                                <li><a class="dropdown-item remove-item-btn" data-bs-toggle="modal" href="javascript:void(0);" (click)="confirm(deleteModel,data.id)">Delete</a></li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                        <div class="noresult" style="display: none">
                            <div class="text-center">
                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#121331,secondary:#08a88a" style="width:75px;height:75px">
                                </lord-icon>
                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                <p class="text-muted mb-0">We've searched more than 150+ API Keys We did not find any
                                    API for you search.</p>
                            </div>
                        </div>
                    </div>
                    <!-- Pagination -->
                    <ngb-pagination class="d-flex justify-content-end pt-2 hstack gap-2" [collectionSize]="allapikeys?.length" [(page)]="service.page" [pageSize]="service.pageSize" (pageChange)="changePage()" aria-label="Custom pagination">
                        <ng-template ngbPaginationPrevious let-page let-pages="pages">
                            <i class="ci-arrow-left me-2"></i>
                            Prev
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            Next
                            <i class="ci-arrow-right ms-2"></i>
                        </ng-template>
                    </ngb-pagination>
                </div>
                <div id="elmLoader">
                    <div class="spinner-border text-primary avatar-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->
</div>
<!-- end row -->

<!-- Modal -->
<ng-template #content role="document" let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Create API Key</h5>
        <button type="button" class="btn-close" id="close-modal" data-bs-dismiss="modal" aria-label="Close" (click)="modal.dismiss('close click')"></button>
    </div>
    <div class="modal-body">
        <div id="api-key-error-msg" class="alert alert-danger py-2 d-none">Please enter api key name</div>
        <input type="hidden" id="apikeyId">
        <div class="mb-3">
            <label for="api-key-name" class="form-label">API Key Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="api-key-name" placeholder="Enter api key name" [(ngModel)]="apiname">
        </div>
        <div class="mb-3 d-none" id="apikey-element">
            <label for="api-key" class="form-label">API Key</label>
            <input type="text" class="form-control" id="api-key" [(ngModel)]="apikeyField" disabled value="b5815DE8A7224438932eb296Z5">
        </div>

    </div>
    <div class="modal-footer">
        <div class="hstack gap-2 justify-content-end">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="modal.dismiss('close click')">Close</button>
            <button type="button" class="btn btn-primary" id="createApi-btn" (click)="createApi()">Create API</button>
            <button type="button" class="btn btn-primary d-none" id="add-btn" (click)="addApi()">Add</button>
            <button type="button" class="btn btn-primary d-none" id="edit-btn" (click)="editApi()">Save Changes</button>
        </div>
    </div>
    <!-- </form> -->
</ng-template>
<!-- end modal -->

<!-- removeItemModal -->
<ng-template #deleteModel let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2 text-center">
                <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p class="text-muted mx-4 mb-0">Are you Sure You want to Remove this API Key ?</p>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
                <button type="button" class="btn w-sm btn-danger " id="delete-product" (click)="deleteData(deleteId)">Yes, Delete It!</button>
            </div>
        </div>
    </div><!-- /.modal-content -->
</ng-template>